// extracted by mini-css-extract-plugin
module.exports = {"Slide":"Slide_Slide__3_Oxu","Image":"Slide_Image__18-ii","Alt":"Slide_Alt__1yNNC","isDark":"Slide_isDark__3HvV8"};